import { ButtonDefault } from '@/components/common/Button'
import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { type IconType } from '@/defs/icon'
import { TABS_PRECON, type TabType } from '@/defs/tab'
import { useLinkInternal } from '@/hooks/useLinkInternal'

import styles from './FeaturedRecJumpButtons.module.scss'

type JumpButtonType = TabType & {
  hash: string
  icon: IconType
}

const PRECON_JUMP_BUTTONS: JumpButtonType[] = TABS_PRECON.map((t) => ({
  ...t,
  hash: 'nav-tabs',
  icon: t.label === 'Adds' ? 'plus' : 'scissors',
}))

export const FeaturedRecJumpButtons = () => {
  const { buildRelative } = useLinkInternal()

  return (
    <div className={styles.container}>
      <p className={styles.heading}>
        <IconWithLabel iconBefore='link' iconBeforeMargin='sm' iconBeforeSize='sm'>
          Common changes to this precon
        </IconWithLabel>
      </p>
      <ul className={styles.list}>
        {PRECON_JUMP_BUTTONS.map(({ hash, icon, label, route }, i) => (
          <li key={i}>
            <ButtonDefault
              as='LinkRoute'
              colorScheme='content'
              hash={hash}
              href={buildRelative(route)}
              variant='outline'
            >
              <IconWithLabel iconBefore={icon}>{label}</IconWithLabel>
            </ButtonDefault>
          </li>
        ))}
      </ul>
    </div>
  )
}
